
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[athleteSlug]/merch/[productSlug]",
      function () {
        return require("private-next-pages/[athleteSlug]/merch/[productSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[athleteSlug]/merch/[productSlug]"])
      });
    }
  